<template>
    <section>
        <div class="container is-fluid mt-6">
        <b-steps
            v-model="activeStep" @change="processStep"
            :animated="true" :rounded="true" :has-navigation="true" label-position="bottom"
            icon-prev="chevron-left"
            icon-next="chevron-right"
            mobile-mode="minimalist">

            <template
                slot="navigation"
                slot-scope="{previous, next}">
                <prev-next :step="activeStep" :previous="previous" :next="next" :finaliseBattle="finaliseBattle" :locked="locked"></prev-next>
            </template>
            
            <b-step-item step="1" label="Units" value="1" :clickable="true">
                <h1 class="title has-text-centered">Who fought in this battle</h1>
                <step-one :units_selected.sync="units_selected" :force_units.sync="force_units"></step-one>
            </b-step-item>

            <b-step-item step="2" value="2" label="Damage" :clickable="true">
                <h1 class="title has-text-centered">Take out of action tests</h1>
                
                <b-table :data="units_selected" >
                     <template slot-scope="props">
                        <b-table-column field="name" label="Name">
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column field="type" label="Unit">
                            <template v-if="props.row.size > 1"> {{ props.row.type }} <br/><span class="is-size-7">({{ props.row.size}} model squad)</span></template>
                            <template v-else>{{ props.row.type }}</template>
                        </b-table-column>

                        <b-table-column field="battlefield_role" label="Role">
                            {{ props.row.battlefield_role }} 
                        </b-table-column>

                        <b-table-column field="power_rating" label="Power" numeric>
                            {{ props.row.power_rating}} 
                        </b-table-column>

                        <b-table-column field="crusade_pts" label="Crusade" numeric>
                            {{ props.row.crusade_pts}} 
                        </b-table-column>

                        <b-table-column field="experience_pts" label="XP" numeric>
                            {{ props.row.experience_pts}} 
                        </b-table-column>

                        <b-table-column label="Destroyed" numeric width=250 >
                            <div class="actions">
                                <div class="buttons has-addons is-right are-small" >
                                    <div  v-if="props.row.draft_info.out_of_action_roll == 1 && !(props.row.draft_info && props.row.draft_info.damaged)">
                                        <b-button tabindex=0 type="is-outlined" @click="chooseDevastatingBlow(props.index)">Blow</b-button>
                                        <b-button tabindex=0 type="is-outlined" @click="showScarModal(props.index)">Scar</b-button>
                                    </div>
                                    <b-button tabindex=0 v-if="!props.row.draft_info.out_of_action_roll" type="is-primary" @click="autoOutOfActionTest(props.index)" icon-left="dice"></b-button>
                                    <span v-else><b-icon class="ml-2" :icon="dice_icons[props.row.draft_info.out_of_action_roll]"></b-icon></span>
                                </div>
                                
                                <b-taglist v-if="props.row.draft_info.battle_scars && props.row.draft_info.battle_scars.filter(e => e.recent).length>0" attached>
                                    <b-tag type="is-dark">Scar</b-tag>
                                    <b-tag ellipsis type="is-warning">{{ props.row.draft_info.battle_scars.filter(e => e.recent).map(e => e.title).join(',') }}</b-tag>
                                </b-taglist>

                                <b-taglist v-if="props.row.draft_info && props.row.draft_info.damaged && props.row.draft_info.devastating_blow_damage" attached>
                                    <b-tag type="is-dark">Devastating Blow</b-tag>
                                    <b-tag ellipsis type="is-warning">-{{props.row.draft_info.devastating_blow_damage}} XP</b-tag>
                                </b-taglist>

                            </div>
                            
                        </b-table-column>
                    </template>
                </b-table>

                <b-modal v-if="chosen_unit" :active.sync="battle_scar_modal.active"
                    has-modal-card
                    trap-focus
                    :destroy-on-hide="false"
                    aria-role="dialog"
                    aria-modal>

                        <form @submit.prevent>
                        <div class="modal-card" style="width: auto">
                            <header class="modal-card-head">
                                <p class="modal-card-title">{{chosen_unit.name}} is Scarred</p>
                            </header>
                            <section class="modal-card-body">
                            <b-field label="Scar Trait">
                                <b-input
                                    type="input"
                                    v-model="battle_scar_modal.scar"
                                    placeholder="e.g. Lost Leg">
                                </b-input>
                            </b-field>

                            <template v-if="chosen_unit.draft_info.battle_scars">
                            <h2>Existing Scars</h2>
                            <b-taglist>
                                <b-tag v-for="scar in chosen_unit.draft_info.battle_scars" :key="scar.title" type="is-danger">{{scar.title}}</b-tag>
                            </b-taglist>
                            </template>

                            </section>

                            <footer class="modal-card-foot">
                                <button class="button" type="button" @click="clearScarModal">Cancel</button>
                                <button class="button is-primary" @click="addScarToUnit(chosen_unit)">Store</button>
                            </footer>
                        </div>
                    </form>
                </b-modal>

            </b-step-item>

            <b-step-item step="3" value="3" label="Experience" :clickable="true">
                <h1 class="title has-text-centered">List activities that gave experience</h1>

                <b-table :data="units_selected" >
                     <template slot-scope="props">
                        <b-table-column field="name" label="Name">
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column field="type" label="Unit" width=400>
                            <template v-if="props.row.size > 1"> {{ props.row.type }} <br/><span class="is-size-7">({{ props.row.size}} model squad)</span></template>
                            <template v-else>{{ props.row.type }}</template>
                        </b-table-column>

                        <!-- <b-table-column field="battlefield_role" label="Role">
                            {{ props.row.battlefield_role }} 
                        </b-table-column> -->

                        <b-table-column field="experience" label="Exp.">
                            {{ props.row.experience_pts }} 
                        </b-table-column>
                        
                        <b-table-column field="experience" label="Survived">
                             {{ props.row.draft_info.devastating_blow_damage ? `-${props.row.draft_info.devastating_blow_damage}` : "+1" }}
                        </b-table-column>

                        <b-table-column field="psychic" label="Psychic Tally" width=85>
                            <b-input v-model.number="props.row.draft_info.combat.psychic"></b-input>
                        </b-table-column>

                        <b-table-column field="ranged" label="Ranged Tally" width=85>
                            <b-input v-model.number="props.row.draft_info.combat.ranged"></b-input>
                        </b-table-column>
                        
                        <b-table-column field="melee" label="Melee Tally" width=85>
                            <b-input v-model.number="props.row.draft_info.combat.melee"></b-input>                        
                        </b-table-column>

                        <b-table-column field="agendas" label="Agenda" width=85>
                            <b-input v-model.number="props.row.draft_info.agenda_exp"></b-input>                        
                        </b-table-column>

                        <b-table-column label="Marked for Greatness" numeric >
                            <div class="actions">
                                <template v-if="props.row.draft_info.marked_for_greatness"><b-icon class="ml-2" icon="award"></b-icon> <span class="is-size-6">Marked</span></template>
                                <div v-else class="buttons has-addons is-right are-small" >
                                    <b-button type="is-primary is-outlined" icon-left="award"
                                        :disabled="props.row.draft_info.devastating_blow_damage > 0" 
                                        @click="markForGreatness(props.index)">
                                        Mark 
                                    </b-button>
                                </div>
                            </div>
                        </b-table-column>

                        <!-- <b-table-column field="" label="Debug">
                            {{ props.row.draft_info }} 
                        </b-table-column> -->

                    </template>
                </b-table>

            </b-step-item>

            <b-step-item step="4" value="4" label="Honours" :clickable="true">
                <h1 class="title has-text-centered">Assign honours to units</h1>
                 <b-table :data="units_selected">
                     <template slot-scope="props">
                        <b-table-column field="name" label="Name">
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column field="experience" label="XP">
                            <change-flow field="experience" :options="{show_title: false}" :current_value="props.row.experience_pts" :new_value="props.row.draft_info.new_experience_pts"></change-flow>
                        </b-table-column>

                        <b-table-column field="rank" label="Rank">
                            <change-flow field="rank" :options="{show_title: false, show_flow: false}" :current_value="props.row.draft_info.new_rank || props.row.rank" :new_value="props.row.draft_info.new_rank || props.row.rank"></change-flow>
                        </b-table-column>

                        <!-- <b-table-column field="draft" label="Draft">
                            <pre>{{ props.row.draft_info }}</pre>
                            <pre>{{ props.row.combat_totals }}</pre>
                        </b-table-column> -->

                        <b-table-column field="honours" label="Honours">
                            <template v-for="(honour,index) in props.row.draft_info.new_honours"> 
                                <b-field v-if="props.row.draft_info.new_honours[index] "  
                                        :key="`${index}-field`" 
                                    >
                                    <b-select placeholder="Type" v-model="props.row.draft_info.new_honours[index].type">
                                        <option value="battle-trait" >Battle Trait</option>
                                        <option value="weapon-enhancement">Weapon Enhancement</option>
                                        <option value="psychic-fortitude">Psychic Fortitude</option>
                                        <option value="crusade-relic">Crusade Relic</option>
                                    </b-select>
                                    <b-input type="text" expanded v-model="props.row.draft_info.new_honours[index].details"></b-input>                        
                                </b-field>
                            </template>

                            
                        </b-table-column>
                        
                     </template>
                 </b-table>
            </b-step-item>

            <b-step-item step="5" value="5" label="Finish" :clickable="true">
                <h1 class="title has-text-centered">Confirm everything is correct</h1>
                <div class="columns is-multiline is-mobile">
                    <unit-summary v-for="unit in units_selected" :unit="unit" :key="unit.uid"></unit-summary>
                </div>
                <!-- <pre>{{ units_selected }}</pre> -->
            </b-step-item>
            
        </b-steps>

        </div>
    </section>
</template>

<script>
    import { mapState, mapActions } from "vuex"
    import UnitSummary from "./UnitSummary.vue"
    import ChangeFlow from './ChangeFlow.vue'
    import PrevNext from "./PrevNext.vue"
    import StepOne from "./Step1.vue"
    export default {
        components: { UnitSummary, ChangeFlow, PrevNext, StepOne},
        props: ['force_id','battle_id','initial_step'],
        data() {
            return {
                locked: false,
                battle_scar_modal: {
                    active: false,
                    scar: ''
                },
                chosen_unit: { draft_info: {} },
                activeStep: this.initial_step || 0,
                force_units: [],
                units_selected: [],
                dice_icons: ['dice','skull-crossbones','dice-two','dice-three','dice-four','dice-five','dice-six',]
            }
        },
        computed: {
            ...mapState(['profile','units']),
        },
        created(){
            console.log('Created',this.activeStep,this.profile.uid);
            if(this.profile.uid && this.units) { this.loadProgress() }
        },
        watch: {
            profile() { console.log('watch Profile'); if(this.profile.uid && this.units) { this.loadProgress() } },
            units() { console.log('watch Units'); if(this.profile.uid && this.units) { this.loadProgress() }}
        },
        methods: {
            ...mapActions(['saveBattleDraft','loadBattleDraft','updateForceWithBattle']),
            processStep(step) {
                this.saveProgress(step)
                if(step == 4) { this.units_selected.forEach( unit => this.generateHonourInformation(unit) ) }
            },
            autoOutOfActionTest(unit_index) {
                let unit = this.units_selected[unit_index]
                unit.draft_info.out_of_action_roll = Math.ceil(Math.random()*6)
                this.units_selected.splice(unit_index,1,unit)
            },
            loadProgress() {
                if(this.profile && this.units.length > 0) {
                    console.log(' --- Loading progress: Force,',this.force_id,'Battle,',this.battle_id,' Profile,',this.profile.uid,' Units,',this.units.length)
                    this.loadBattleDraft({force_id: this.force_id, battle_id: this.battle_id}).then( draft => {
                        if(draft) {
                            this.locked = draft.locked
                            this.force_units = this.units
                                .filter( (unit) => { return unit.force_id == this.force_id})
                                .map((unit) => {
                                    let draft_unit = draft.units.find((draft_unit) => { return draft_unit.uid == unit.uid})
                                    if(draft_unit) { 
                                        return draft_unit 
                                    } else { 
                                        return { draft_info: { combat: { any: 0, melee: 0, ranged: 0, psychic: 0,}, agenda_exp: 0, },...unit,}
                                    }
                                })    
                                
                            if(this.activeStep < 2) { 
                                console.log('Initialisation step')
                                    
                                let checked_unit_ids =  draft.units.map( unit => unit.uid)
                                // Merge draft info
                                this.units_selected = this.force_units.filter( (unit) => { return checked_unit_ids.includes(unit.uid) } )
                            } else { // Otherwise load all units
                                console.log('Non initialisation step')
                                this.units_selected = draft.units
                                if(this.activeStep == 4) { this.units_selected.forEach( unit => this.generateHonourInformation(unit) ) }
                            }
                        } else {
                            console.log('New Battle')
                            this.force_units = this.units
                                .filter( (unit) => { return unit.force_id == this.force_id})
                                .map((unit) => {return { draft_info: { combat: { any: 0, melee: 0, ranged: 0, psychic: 0,}, agenda_exp: 0, },...unit,}})        
                            this.units_selected = []
                        }
                    })
                } else { 
                    console.log('Not ready to load progress')
                }
            },
            saveProgress(step) {
                if(this.locked) {
                    console.warning("Cannot save, locked")
                } else {
                    if(step >= 1) {
                        console.log('Saving stage ',step) 
                        this.saveBattleDraft({force_id: this.force_id, battle_id: this.battle_id, units: this.units_selected})
                    }    
                }
                this.$router.push({name: 'battle.workflow', params: { battle_id: this.battle_id, force_id: this.force_id, step: step}})
            },
            showScarModal(unit_index) {
                console.log('batle scra for:',unit_index)
                this.chosen_unit = this.units_selected[unit_index]
                this.battle_scar_modal.active  = true
            },
            clearScarModal(){
                this.battle_scar_modal.active = false
                this.battle_scar_modal.scar = ''
            },
            addScarToUnit(unit) {
                unit.draft_info = unit.draft_info || {}
                unit.draft_info.battle_scars = unit.draft_info.battle_scars || []
                unit.draft_info.battle_scars.push({title: this.battle_scar_modal.scar, recent: true})
                unit.draft_info.damaged = true
                this.updateUnit(unit)
                this.clearScarModal()
            },
            updateUnit(new_unit) {
                console.log('Updating:',new_unit.uid)
                let unit_index = this.units_selected.findIndex( live_unit => live_unit.uid == new_unit.uid )
                this.units_selected.splice(unit_index,1,{...new_unit})
            },
            chooseDevastatingBlow(unit_index) { 
                let unit = this.units_selected[unit_index]
                unit.draft_info = unit.draft_info || {}
                unit.draft_info.devastating_blow_damage = Math.ceil(Math.random()*6)
                unit.draft_info.damaged = true
                this.updateUnit(unit)
            },
            markForGreatness(unit_index) {
                this.units_selected.forEach((unit,index) => {
                    unit.draft_info.marked_for_greatness = index == unit_index
                    this.updateUnit(unit)
                })
            },
            generateHonourInformation(unit) { 
                let previous_combat_totals = unit.combat_totals || { any: 0, melee: 0, ranged: 0, psychic: 0,}
                let devastated = unit.draft_info.devastating_blow_damage && unit.draft_info.devastating_blow_damage > 0
                let survived = devastated ? 0 : 1  
                unit.draft_info.combat.melee = unit.draft_info.combat.melee == "" ? 0 : unit.draft_info.combat.melee
                unit.draft_info.combat.psychic = unit.draft_info.combat.psychic == "" ? 0 : unit.draft_info.combat.psychic
                unit.draft_info.combat.ranged = unit.draft_info.combat.ranged == "" ? 0 : unit.draft_info.combat.ranged
                unit.draft_info.agenda_exp = unit.draft_info.agenda_exp == "" ? 0 : unit.draft_info.agenda_exp
                
                let total_kills = (unit.draft_info.combat.melee || 0) +  (unit.draft_info.combat.psychic || 0 )+ (unit.draft_info.combat.ranged || 0)
                let leftover_kills = previous_combat_totals.any % 3
                let kills_since_last_promotion = leftover_kills + total_kills
                let dealers_of_death = Math.floor(kills_since_last_promotion/3)
                let marked_for_greatness = unit.draft_info.marked_for_greatness && !devastated ? 3 : 0 
                let agendas = unit.draft_info.agenda_exp && !devastated ? unit.draft_info.agenda_exp : 0

                let new_experience_pts = unit.experience_pts 
                    + survived 
                    + dealers_of_death
                    + marked_for_greatness
                    + agendas
                if(devastated) { new_experience_pts = Math.max(0,(new_experience_pts - unit.draft_info.devastating_blow_damage)) }
                let ranks = ['battle-ready','blooded','battle-hardened','heroic','legendary']
                let new_rank = unit.rank
                if (new_experience_pts>50 ) {new_rank = ranks[4];}
                else if (new_experience_pts>30 ) {new_rank = ranks[3];}
                else if (new_experience_pts>15 ) {new_rank = ranks[2];}
                else if (new_experience_pts>5 ) {new_rank = ranks[1];}
                
                let old_index = ranks.indexOf(unit.rank)
                let new_index = ranks.indexOf(new_rank)
                let promotion_amount = Math.max(0,new_index - old_index)
                // console.log('Promo calculation', unit.uid, unit.rank,old_index, '->',new_rank,new_index, promotion_amount)
                let crusade_boost = promotion_amount * (unit.power_rating > 10 ? 2 : 1)
                let crusade_penalty = unit.draft_info.battle_scars ? unit.draft_info.battle_scars.length : 0 
                let new_crusade_pts = unit.crusade_pts + crusade_boost - crusade_penalty
                let new_honours = null 
                if(promotion_amount>0) { 
                    console.log('Promo calculation', unit.uid, unit.rank,old_index, '->',new_rank,new_index, promotion_amount)
                    let current_honour_count = unit.draft_info.new_honours && Array.isArray(unit.draft_info.new_honours) ? unit.draft_info.new_honours.length : 0
                    console.log('hnr cnt',current_honour_count,'prmo amt',promotion_amount)
                    let elms_to_add = Math.max(0,promotion_amount - current_honour_count) 
                    let elms_to_remove = Math.max(0,current_honour_count - promotion_amount ) 
                    console.log('add',elms_to_add, 'remove', elms_to_remove)
                    let blank_array = new Array(elms_to_add).fill({ type: '', details: '' })
                    console.log('blank',blank_array.length)
                    let orig_honours = Array.isArray(unit.draft_info.new_honours) ? unit.draft_info.new_honours : []
                    console.log('orig',orig_honours.length)
                    let elms_to_keep = Math.min(promotion_amount,orig_honours.length)
                    console.log('keep:',elms_to_keep)
                    console.log('orig',orig_honours.length)
                    orig_honours.splice(elms_to_keep,elms_to_remove,...blank_array)
                    new_honours = orig_honours
                    console.log('new', new_honours.length)
                } else { new_honours = [] }
                if(!Array.isArray(unit.draft_info.new_honours)) { unit.draft_info.new_honours = [] }
                unit.draft_info.new_honours.splice(0,1000,...new_honours) // TODO could this just be an assignment
                unit.draft_info.new_rank = new_rank
                unit.draft_info.new_experience_pts = new_experience_pts
                unit.draft_info.new_crusade_pts = new_crusade_pts
                // this.updateUnit(unit) // This caused issues and reset the units_selected as far as the first step was concerned
            },
            finaliseBattle(win_or_lose) {
                // Update all the units
                let new_units = this.units_selected.map((unit) => { 
                    let merge = unit.draft_info
                    let new_unit = {...unit}
                    delete new_unit.draft_info
                    // Update battle totals
                    new_unit.battle_totals = new_unit.battle_totals ? new_unit.battle_totals : { fought: 0, survived: 0 }
                    new_unit.battle_totals.fought += 1
                    if((merge.out_of_action_roll || 0)<1)  { new_unit.battle_totals.survived += 1 } 
                    // Update combat totals
                    new_unit.combat_totals = new_unit.combat_totals ? new_unit.combat_totals : { any: 0, psychic: 0, melee: 0, ranged: 0, }
                    new_unit.combat_totals.psychic += merge.combat.psychic
                    new_unit.combat_totals.melee += merge.combat.melee
                    new_unit.combat_totals.ranged += merge.combat.ranged
                    new_unit.combat_totals.any += (merge.combat.psychic + merge.combat.melee + merge.combat.ranged)
                    // Store Honours
                    new_unit.honours = (new_unit.honours || []).concat(merge.new_honours || [])
                    // Store scars
                    new_unit.battle_scars = (new_unit.battle_scars || []).concat(merge.battle_scars || [])
                    // Store XP, CR and Rank
                    new_unit.experience_pts = merge.new_experience_pts
                    new_unit.crusade_pts = merge.new_crusade_pts
                    new_unit.rank = merge.new_rank

                    return new_unit
                })
                this.saving()
                this.updateForceWithBattle({ force_id: this.force_id, uid: this.battle_id, result: win_or_lose, units: new_units }).then(() => {
                    this.$router.push({name: 'force.listing'})
                    this.loadingComponent.close()
                })
                
            },
            saving() {
                 this.loadingComponent = this.$buefy.loading.open({ container: null })
            }
        },
    }

</script>

<style lang="scss" scoped>
    .actions {
         display: flex;
        flex-direction: row-reverse;
        align-items: flex-start;
        align-content: flex-end;

         .buttons:not(:last-child) {
            margin-bottom:0;
         }
    }
</style>